import type { ResourcesConfig } from 'aws-amplify';

// Build-time defaults (single source); runtime config.js overrides them per env.
const rt =
  (typeof window !== 'undefined' && (window as { __APP_CONFIG__?: { cognito?: { userPoolId?: string; userPoolClientId?: string } } }).__APP_CONFIG__?.cognito) || {};

export const portalApiEndpoint =
  process.env.REACT_APP_API_URL || window.location.origin + '/api';

export const awsConfig: { Auth: ResourcesConfig['Auth'] } = {
  Auth: {
    Cognito: {
      userPoolClientId: rt.userPoolClientId ?? '5g2arnvo18e2bii5j9mriccl3m',
      userPoolId: rt.userPoolId ?? 'eu-west-1_1wJXCF3Dc',
    },
  },
};
